// packages/brand-config/src/brandAssetUrls.ts
import type { BrandAssets } from "./types";

/** 构建产物中品牌静态资源 URL 前缀（与 webpack CopyWebpackPlugin 输出目录一致） */
export const getBrandAssetsPublicBase = (brandId: string): string =>
  `/brand-assets/${brandId}`;

/**
 * 生成品牌 Logo / favicon 的站点根路径（由 initBrandTheme 写入 CSS 变量）
 * 文件需放在 brands/{id}/assets/ 下，构建时拷贝到 dist/brand-assets/{id}/
 */
export type BrandLogoExtension = "svg" | "png";

export const createBrandAssetUrls = (
  brandId: string,
  options?: { logoExtension?: BrandLogoExtension }
): BrandAssets => {
  const ext = options?.logoExtension ?? "svg";
  const base = getBrandAssetsPublicBase(brandId);
  return {
    logoLight: `${base}/logo-light.${ext}`,
    logoDark: `${base}/logo-dark.${ext}`,
    logoShrink: `${base}/logo-shrink.${ext}`,
    /** 构建时由 webpack 将 logo.ico 拷贝为站点根 /favicon.ico */
    favicon: "/favicon.ico",
  };
};
